import Image from 'next/image';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import {
  applyTruncationForScreen,
  findImageByKey,
  findImageByKeyWebLarge,
  findValueByKey,
  formatDateLang,
  getResourceContentImageSrc,
  getTarget,
  isItUndefined,
  isLinkAbsolute,
  removeNbsp,
  stripHtml,
} from '../../util/DataUtil';

const TempalteFeaturedContent = ({ children }) => {
  const featured = children?.field_featured_posts;
  const [titles, setTitles] = useState([]);
  const title = isItUndefined(children?.field_title_color);
  const router = useRouter();
  const isBlogVariant =
    children?.field_featured_content_variant?.[0]?.value ===
    'blog_featured_content';
  const { asPath } = router;
  const getFullTitle = (item) => {
    const titleFromTemplate = findValueByKey(
      'template_title_block_type',
      item?.field_template_blocks
    )?.field_template_title?.[0]?.value;

    if (titleFromTemplate) return titleFromTemplate;

    const heroTitle = findValueByKey(
      'hero_graphic_block_type',
      item?.field_template_blocks
    )?.field_formatted_title?.[0]?.value;

    return removeNbsp(stripHtml(heroTitle));
  };

  const truncate = () => {
    if (!featured?.length) {
      setTitles([]);
      return;
    }

    if (isBlogVariant) {
      setTitles(featured.map((item) => getFullTitle(item)));
      return;
    }

    const next = featured.map((item, index) =>
      applyTruncationForScreen(
        getFullTitle(item),
        index === 0 ? 120 : 47,
        50,
        60
      )
    );

    setTitles(next);
  };

  useEffect(() => {
    truncate();
  }, [featured, isBlogVariant]);

  const onChipClick = (event, category) => {
    if (typeof window !== 'undefined') {
      // localStorage.setItem('name', category[0]['name'])
        let url=''
        if (typeof window !== undefined) {
            url = window.location.pathname;
        }

        if (isBlogVariant) {
        router.push({
          pathname: '/resources/articles',
          query: { contentTag: category[0].name.toLowerCase() },
          hash: 'articles-cards-container',
        });
      } else
        router.push({
          pathname: '/resources',
          query: { category: category[0]['name'].toLowerCase() },
        });
    }
  };

  const renderBlogInfo = (blogItem) => {
    const authors = blogItem?.field_authors || [];
    const authorNames =
      authors
        ?.map((a) => a?.field_author_full_name?.[0]?.value)
        .filter(Boolean)
        .join(', ') || null;
    const publishDate = isItUndefined(blogItem?.field_publish_date) || null;
    const timeToRead = isItUndefined(blogItem?.field_time_to_read) || null;
    return (
      <div className={'blog-info'}>
        <span className={'author-name info-item'}>
          {authorNames ? `${authorNames}` : ''}
        </span>
        {authorNames && publishDate ? (
          <span className={'separator separator-inline info-item'}>
            {' | '}
          </span>
        ) : null}
        {/*{authors.length > 1 && !isFeaturedItem && <br />}*/}
        <span className={'publish-date info-item'}>
          {publishDate ? formatDateLang(publishDate) : ''}
        </span>
        {(authorNames || publishDate) && timeToRead ? (
          <span className={'separator'}>{' | '}</span>
        ) : null}
        <span className={'blog-read-time info-item'}>
          {timeToRead ? timeToRead : ''}
        </span>
      </div>
    );
  };

  const renderPills = (blogItem, smallItems = false) => {
    const limit = smallItems ? 2 : 3;
    return (
      <div className={'blog-pills'}>
        <span
          className={`blog-pill`}
          onClick={(event) =>
            onChipClick(event, [
              { name: blogItem?.field_template_category?.[0]?.name },
            ])
          }
        >
          {blogItem?.field_template_category?.[0]?.name}
        </span>
        {blogItem?.field_template_secondary_categor
          ?.slice(0, limit - 1)
          ?.map((item, index) => (
            <span
              className={`blog-pill`}
              onClick={(event) =>
                onChipClick(event, [
                  {
                    name: item.name,
                  },
                ])
              }
            >
              {item.name}
            </span>
          ))}
      </div>
    );
  };

  const renderMainFeatured = () => {
    return (
      <div className={`item-big ${isBlogVariant ? 'blog' : ''}`}>
        <a
          href={
            featured[0]?.['url-alias']?.length ? featured[0]['url-alias'] : '/'
          }
          target={getTarget(featured[0]?.['url-alias'])}
          className={'img-container div-resource-content-link'}
        >
          <Image
            layout="fill"
            alt="featured"
            src={getResourceContentImageSrc(featured[0])}
          />
        </a>

        {featured[0] &&
          featured[0]?.field_content_type_templat &&
          featured[0]?.field_content_type_templat[0]?.name &&
          !isBlogVariant && (
            <span className={'category'}>
              {featured[0]?.field_content_type_templat[0]?.name}
              {isItUndefined(featured[0]?.field_time_to_read) ? ',' : ''}{' '}
              {isItUndefined(featured[0]?.field_time_to_read)}
            </span>
          )}

        <a
          href={
            featured[0]?.['url-alias']?.length ? featured[0]['url-alias'] : '/'
          }
          target={getTarget(featured[0]?.['url-alias'])}
          className={`resource-title-link ${isBlogVariant ? 'blog' : ''}`}
        >
          <span className={`title ${isBlogVariant ? 'blog' : ''}`}>
            {isItUndefined(featured[0]?.field_display_title)
              ? isItUndefined(featured[0]?.field_display_title)
              : titles[0]}
          </span>
          {isBlogVariant ? (
            <div>
              <p className={'blog-description'}>
                {isItUndefined(featured[0].field_slug)}
              </p>
              {renderBlogInfo(featured[0])}
            </div>
          ) : null}
        </a>

        {featured[0]?.field_template_category?.[0]?.name ? (
          <>
            {' '}
            {isBlogVariant ? (
              renderPills(featured[0])
            ) : (
              <span
                className={`second-category category-hover`}
                onClick={(event) =>
                  onChipClick(event, [
                    { name: featured[0]?.field_template_category?.[0]?.name },
                  ])
                }
              >
                {featured[0]?.field_template_category?.[0]?.name}
              </span>
            )}
          </>
        ) : (
          <span className="second-category second-category-0-mt category-hover"></span>
        )}

        <hr className={'item-big-hr'} />
      </div>
    );
  };

  const renderFeatured = () => {
    return featured?.map((item, index) => {
      if (index === 0) return null;

      const href = item?.['url-alias']?.length ? item['url-alias'] : '/';
      const target = getTarget(item?.['url-alias']);

      return (
        <div key={index} className={`item ${isBlogVariant ? 'blog' : ''}`}>
          {index === 1 && (
            <a
              href={href}
              target={target}
              className={'div-resource-content-link img-container'}
            >
              <Image
                priority
                layout="fill"
                alt="featured"
                src={getResourceContentImageSrc(item)}
              />
            </a>
          )}

          {!isBlogVariant ? (
            <span className={'category'}>
              {item?.field_content_type_templat?.[0]?.name && (
                <>
                  {item.field_content_type_templat[0].name}
                  {isItUndefined(item?.field_time_to_read) ? ',' : ''}{' '}
                  {isItUndefined(item?.field_time_to_read)}
                </>
              )}
            </span>
          ) : null}

          <a
            href={href}
            target={target}
            className={`resource-title-link ${isBlogVariant ? 'blog' : ''}`}
          >
            <span className={`title ${isBlogVariant ? 'blog' : ''}`}>
              {isItUndefined(item?.field_display_title)
                ? isItUndefined(item?.field_display_title)
                : titles[index]}
            </span>
            {isBlogVariant ? renderBlogInfo(item) : null}
          </a>

          {isBlogVariant ? (
            renderPills(item, true)
          ) : (
            <span
              className={`second-category category-hover${!item?.field_template_category?.[0]?.name ? ' undefined-category' : ''}`}
              onClick={(event) =>
                onChipClick(event, [
                  { name: item?.field_template_category?.[0]?.name || '' },
                ])
              }
            >
              {item?.field_template_category?.[0]?.name || ''}
            </span>
          )}

          <hr />
        </div>
      );
    });
  };

  return (
    <div className={`template-featured-content ${isBlogVariant ? 'blog' : ''}`}>
      <div className="inner-container">
        {isBlogVariant ? null : (
          <>
            <div
              className="page-sub"
              dangerouslySetInnerHTML={{ __html: title }}
            />
            <hr />
          </>
        )}
        <div className={'featured'}>
          {renderMainFeatured()}
          <div className={`small-items ${isBlogVariant ? 'blog' : ''}`}>
            {renderFeatured()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TempalteFeaturedContent;
